import { BackgroundImage } from 'library/ts/ui/components/background/BackgroundImage';
export class LoadingAnimationBackgroundImage {
    #enabled;
    #config;
    #utils;
    #container;
    #overlayContainer;
    #imageInstance;
    #loadingAnimationContainer;
    constructor(loadingAnimationContainer, config) {
        this.#loadingAnimationContainer = loadingAnimationContainer;
        this.#config = config;
        this.#utils = window.PARA.PlayerServices.Utilities;
        this.#enabled = config?.enabled;
        this.#createBackgroundImageContainer();
    }
    get name() {
        return 'LoadingAnimationBackgroundImage';
    }
    enable = () => {
        this.#enabled = true;
        this.show();
    };
    disable = () => {
        this.#enabled = false;
        this.hide();
    };
    show = () => {
        if (!this.#enabled) {
            return;
        }
        if (this.#utils.Type.isElement(this.#container)) {
            this.#container.style.display = 'block';
        }
        if (this.#utils.Type.isElement(this.#overlayContainer)) {
            this.#overlayContainer.style.display = 'block';
        }
    };
    hide = () => {
        if (this.#utils.Type.isElement(this.#container)) {
            this.#container.style.display = 'none';
        }
        if (this.#utils.Type.isElement(this.#overlayContainer)) {
            this.#overlayContainer.style.display = 'none';
        }
    };
    setImage = (imageURL) => {
        if (this.#utils.URL.valid(imageURL)) {
            this.#config.imageURL = imageURL;
            if (this.#utils.Type.isElement(this.#container)) {
                this.#imageInstance = new BackgroundImage(this.#container, imageURL, {
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    opacity: 1,
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    zIndex: '0'
                }, undefined, undefined, this.#utils, window.SmartTag.runtimeVO);
            }
        }
    };
    #createBackgroundImageContainer = () => {
        if (this.#config?.enabled && this.#utils.URL.valid(this.#config?.imageURL)) {
            const displayStyle = 'block';
            this.#container = this.#utils.DOM.stringToElement(`<div class="loading-animation-background-image" style="display: ${displayStyle};"></div>`);
            this.#loadingAnimationContainer?.appendChild(this.#container);
            const defaultOverlayOpacity = 0.6;
            const overlayOpacity = this.#config?.overlayOpacity ?? defaultOverlayOpacity;
            this.#overlayContainer = this.#utils.DOM.stringToElement(`
				<div style="
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background-color: rgba(0,0,0,${overlayOpacity});
					pointer-events: none;
					z-index: 1;" >
				</div>
			`);
            this.#container?.appendChild(this.#overlayContainer);
            this.#imageInstance = new BackgroundImage(this.#container, this.#config?.imageURL, {
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                opacity: 1,
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                zIndex: '0'
            }, undefined, undefined, this.#utils, window.SmartTag.runtimeVO);
        }
    };
}
